import React, { useState } from 'react'

const ReportButtons = ({ onSearchClick, onReportClick, presets }) => {
  const [selectedId, setSelectedId] = useState('0')

  // Handle search/go button click
  const handleGoClick = () => {
    onSearchClick(selectedId)
  }
  
  // Handle report button click
  const handleReportClick = () => {
    onReportClick(selectedId)
  }

  return (
    <div className='card report-button-wrapper px-5'>
      <div className='card-header align-items-center border-0 mt-4 py-0 px-2'>
        <h3 className='card-title align-items-start flex-column'>Presets</h3>
      </div>

      <div className='card-body pt-0 d-flex justify-content-center flex-column gap-3'>
        <div className='d-flex gap-2'>
          <select
            className='form-select px-2'
            value={selectedId}
            onChange={(e) => setSelectedId(e.target.value)}
          >
            <option value='0'>Select Template</option>
            {presets.map((preset) => (
              <option key={preset.id} value={preset.id}>
                {preset.name}
              </option>
            ))}
          </select>
          <button className='btn btn-primary' onClick={handleGoClick}>
            <i className='bi bi-search'></i>
          </button>
        </div>

        <div className='btn-container'>
          <button className='btn btn-secondary w-100' disabled>
            JSON
          </button>
          <button 
            className='btn btn-primary w-100' 
            onClick={handleReportClick}
          >
            Report
          </button>
        </div>
      </div>
    </div>
  )
}

export { ReportButtons }